<template>
  <div>
    <Navigation :name="userName" @logout="logout" />
    <MainToolbar />
    <ScrollingBanner
      v-if="showGlobalBanner"
      :message="globalBannerMsg"
      :scrollSpeed="'10'"
    />
    <ScrollingBanner v-if="showBanner" :message="bannerMsg" />

    <v-content class="content-style">
      <Banner @toggleBanner="toggleBanner" :isBannerOpen="computeBannerShow">
        <template slot="header"> {{ $t("Subscription Alert") }}!! </template>
        <template>
          {{ subsMessage }} {{ $t("For further queries contact") }}
          <a class="first-link" href="https://support@enerman.in"
            >sales@enerman.in</a
          >
        </template>
      </Banner>
      <!-- TODO set state in v-if as computed property -->
      <v-container grid-list-md fluid pa-1 mt-1 v-if="isRouterView">
        <v-layout column>
          <v-flex style="flex-grow: 0" v-if="isDashboard($route.path)">
            <DashboardSelection
              :items="getDashboardList"
              selection="0"
            ></DashboardSelection>
          </v-flex>
          <v-flex grow>
            <router-view class="full-content-area" />
          </v-flex>
        </v-layout>
      </v-container>
      <HomeBanner v-else />
    </v-content>
    <DownloadListSnackBar></DownloadListSnackBar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
const _ = require("lodash");

import Login from "@/services/login";
import Navigation from "@/components/container/Navigation";
import MainToolbar from "@/components/container/Toolbar";
const ScrollingBanner = () => import("@/components/common/ScrollingBanner");

const Banner = () => import("@/components/Banner");
const HomeBanner = () => import("@/components/home/HomeBanner");
const DashboardSelection = () =>
  import("@/components/common/DashboardSelection");
const DownloadListSnackBar = () =>
  import("@/components/container/DownloadListSnackBar");
import { setTheme } from '@/util/mixin/index.js'

export default {
  components: {
    Banner,
    HomeBanner,
    DashboardSelection,
    Navigation,
    MainToolbar,
    DownloadListSnackBar,
    ScrollingBanner,
  },
  mixins: [setTheme],
  data: () => ({
    isBannerOpen: true,
    showMap: false
  }),
  computed: {
    ...mapGetters([
      "isRenewExceeded",
      "getUserInfo",
      "getSelectedPlantId",
      "getBanner",
      "getGeneralState",
      "getRules",
      "getTotalPlantCount",
      "isDashboard",
      "getDashboardList",
    ]),
    userName() {
      return this.getUserInfo("userName");
    },
    lastRouteSegment() {
      const path = this.$route.path;

      return path.split("/").slice(-1)[0];
    },
    showGlobalBanner() {
      if (!_.isEmpty(this.getGeneralState("activePlant")) && this.getRules("rule")) {
        const compConfig = this.getRules("rule").comp_config;
        return (
          Object.keys(compConfig).length &&
          compConfig.global_banner &&
          Object.keys(compConfig.global_banner.options).length > 0 &&
          compConfig.global_banner.options.state
        );
      }
      return false;
    },
    globalBannerMsg() {
      if (!_.isEmpty(this.getGeneralState("activePlant")) && this.getRules("rule")) {
        const compConfig = this.getRules("rule").comp_config;
        return this.showGlobalBanner
          ? compConfig.global_banner.options.message
          : "";
      }
      return "";
    },
    bannerMsg() {
      const toPath = this.lastRouteSegment;
      if (!_.isEmpty(this.getGeneralState("activePlant")) && this.getRules("rule")) {
        const accessRule = this.getRules("rule").comp_config;
        const comp = Object.keys(accessRule).find((el) => {
          return (
            accessRule[el].options &&
            accessRule[el].options.banner &&
            accessRule[el].options.banner.path === `/${toPath}`
          );
        });
        return comp ? this.getBanner(comp).message || "" : "";
      }
      return "";
    },
    showBanner() {
      return this.bannerMsg && this.bannerMsg.trim() !== "";
    },
    isRouterView() {
      const routerpathArr = this.$route.path.split("/");
      const role = this.getGeneralState("userData")["role"];

      if (role === "super-admin") {
        return true
      }
      return (
        !this.isRenewExceeded(this.getSelectedPlantId) ||
        this.$route.name === "home" ||
        ((role === "admin" || role === "super-admin") &&
          routerpathArr.length > 2 &&
          (routerpathArr[1] === "ics-admin" || routerpathArr[1] === "admin"))
      );
    },
    computeBannerShow() {
      return (
        this.isBannerOpen &&
        this.plantListExpiry &&
        this.$route.path === "/home"
      );
    },
    plantListExpiry() {
      return this.datesCheck("expiry_date") > 0;
    },
    subsMessage() {
      let isExpired = this.datesCheck("expiry_date");

      let key, defMsg;
      switch (isExpired) {
        case 4:
          key = "all_expired";
          defMsg = "Your plant Subscription have expired.";
          break;
        case 3:
          key = "expired";
          defMsg = "The Subscription for some plant has expired.";
          break;
        case 2:
        case 1:
          key = "before_renew";
          defMsg = "The Subscription for some plants will expire soon.";
          break;
        default:
          break;
      }

      return this.computeBannerMessage(key, defMsg);
    },
  },
  async mounted() {
    const missingHandler = (locale, key, vm) => {
      // Return the original text provided in $t() as fallback
      return key;
    };

    // Set up the missing translation handler
    this.$i18n.missing = missingHandler;

    // Set up a custom fallback handler for missing translations
    this.$i18n.fallbackHandler = (missingKey, locale, format, values) => {
      // Return the missing key as the fallback value
      return missingKey;
    };
  },
  methods: {
    ...mapActions(["resetState"]),
    toggleBanner(val) {
      this.isBannerOpen = val;
    },
    async logout() {
      try {
        const payload = {
          token: this.getGeneralState("token"),
          userId: this.getGeneralState("userData").userId,
          email: this.getGeneralState("userData").email,
        };
        await Login.logoutUser(payload);
      } catch (err) {
        console.log(err, "ERROR ERROR ERROR");
      } finally {
        this.resetState();
        this.setDark();
        this.$router.push({
          name: "login",
        });
      }
    },
    datesCheck() {
      if (
        this.getTotalPlantCount ==
        this.getGeneralState("totalExpiredPlantCount")
      ) {
        return 4;
      } else if (this.getGeneralState("totalExpiredPlantCount")) {
        return 3;
      } else if (this.getGeneralState("totalRenewPlantCount")) {
        return 2;
      } else if (this.getGeneralState("aboutToExpireCount")) {
        return 1;
      } else {
        return 0;
      }
    },
    computeBannerMessage(key, defMsg) {
      return this.getUserInfo("banner_messages") &&
        this.getUserInfo("banner_messages").home &&
        this.getUserInfo("banner_messages").home[key]
        ? this.getUserInfo("banner_messages").home[key]
        : defMsg;
    }
  }
};
</script>

<style scoped>
.content-style {
  max-height: calc(100vh - 55px);
  overflow-y: auto;
}

.full-content-area {
  height: 100%;
  width: 100%;
}

.first-link {
  color: #534b00 !important;
  text-decoration-line: underline;
}

.second-link {
  color: #485bff;
  cursor: pointer;
}

.last-update-mini {
  position: absolute;
  left: 0;
  bottom: 16px;
  text-align: center;
  margin-left: -8px;
}

.last-update {
  position: absolute;
  text-align: center;
  width: 100%;
}

@media screen and (max-width: 960px) and (min-width: 510px) {
  .content-style {
    margin: 54px 0px 0px 80px;
  }
}
</style>

<style>
/* Agathsya code ends here */
.scroll-overflow .v-table__overflow::-webkit-scrollbar {
  height: 6px;
  /* width: 50%; */
}

.scroll-overflow {
  overflow-y: scroll;
  scrollbar-color: #ff7347 #f5f5f5;
  scrollbar-width: thin;
}

.scroll-overflow .v-table__overflow::-webkit-scrollbar-thumb {
  background-color: #ff7347;
}
</style>
